import SlideData from "../Interfaces/SlideData";
import {AnyAction, Dispatch} from "@reduxjs/toolkit";
import axios from "axios";
import {uploadPhotoRotateUrl} from "./url";
import {addSlide} from "../store/makerDataSlice";
import * as Sentry from "@sentry/react";
import ym from "react-yandex-metrika";

export default async function rotatePhoto(argsData: any) {

    let slideData = argsData.slideData;
    let dispatch = argsData.dispatch;
    let makerData = argsData.makerData;

    let vkLaunchParams = {};
    if (makerData?.vkLaunchParams?.vk_app_id) {
        for (const [key, value] of Object.entries(makerData.vkLaunchParams)) {
            // @ts-ignore
            vkLaunchParams[key] = value;
        }
    }

    const rotateData = {
        url: slideData.src,
        medium_url: slideData.medium_url,
        thumbnail_url: slideData.thumbnail_url,
        pathInfoFilename: slideData.pathInfoFilename,
        angle: '90'
    };

    const response = await axios.post(
        uploadPhotoRotateUrl,
        rotateData,
        {
            params: vkLaunchParams,
        }
    );

    if (response.data.result == '1') {
        const updatedData = JSON.parse(JSON.stringify(slideData));
        updatedData.src = response.data.url;
        updatedData.medium_url = response.data.medium_url;
        updatedData.thumbnail_url = response.data.thumbnail_url;
        dispatch(addSlide(updatedData));
        ym('reachGoal', 'photoRotate');
    } else {
        throw ({
            message: 'Failed to rotate photo. Error in response.',
            response: response,
            responseConfig: JSON.stringify(response?.config),
            responseData: JSON.stringify(response?.data),
            url: uploadPhotoRotateUrl
        });
    }
}